import {defineMessages} from 'react-intl';

export const messages = defineMessages({
  logoAppliedTo: {
    id: 'ClientLogoField.constants.logoAppliedTo',
    defaultMessage: 'Logo applied to',
  },
  WEB: {
    id: 'ClientLogoField.constants.WEB',
    defaultMessage: 'Web App',
  },
  NOTIFICATION: {
    id: 'ClientLogoField.constants.NOTIFICATION',
    defaultMessage: 'Emails',
  },
  MOBILE: {
    id: 'ClientLogoField.constants.MOBILE',
    defaultMessage: 'Mobile App',
  },
  DESKTOP: {
    id: 'ClientLogoField.constants.DESKTOP',
    defaultMessage: 'Desktop Alerts',
  },
  NONE: {
    id: 'ClientLogoField.constants.NONE',
    defaultMessage: 'None',
  },
});

export const LOGO_TYPE_FIELDS = {
  WEB_APP: 'WEB',
  MOBILE_APP: 'MOBILE',
  NOTIFICATIONS: 'NOTIFICATION',
  DESKTOP: 'DESKTOP',
};

export const CLIENT_LOGOS_FIELD_NAMES = {
  LOGO: 'logo',
  SCOPES: 'scopes',
  LOGOS: 'logos',
};

export const LOGO_SCOPES = {
  ...LOGO_TYPE_FIELDS,
  NONE: 'NONE',
};
